import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '@app/shared/service/session.service';
import { Permissions } from '../models/enums/permissions';

@Injectable({
  providedIn: 'root'
})
export class ActiveStorefrontGuard  {
  constructor(private session: SessionService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    const hasActiveStorefront = !!this.session.storefrontId;
    if (hasActiveStorefront) {
      return true;
    }
    if (this.session.user) {
      const { permissions } = this.session.user;
      const canViewAll = permissions.some(p => p === Permissions.viewAllStorefronts);
      if (canViewAll) {
        return this.router.createUrlTree(['/storefront/all']);
      }
    }
    return this.router.createUrlTree(['/unauthorized']);
  }
}
